/**
 * Beta gate per le route del dominio Agenti vocali (/agents/voice/* + /settings/voice-*).
 *
 * Se l'org corrente non e` in BETA_VOICE_AGENTS_ORG_IDS, redirect a / (home).
 * Non sostituisce ProtectedRoute: si usano insieme.
 *   <BetaVoiceAgentsRoute>
 *     <ProtectedRoute resource="voice_agents" action="view">
 *       <VoiceAgentsListPage />
 *     </ProtectedRoute>
 *   </BetaVoiceAgentsRoute>
 *
 * Quando il beta finisce: rimuovere wrapper dalle route in App.tsx + svuotare
 * BETA_VOICE_AGENTS_ORG_IDS (vedi config/betaOrgs.ts).
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserData } from '../lib/auth';
import { BETA_VOICE_AGENTS_ORG_IDS, canAccessBetaFeature } from '../lib/config/betaOrgs';

interface Props {
  children: React.ReactNode;
}

export function BetaVoiceAgentsRoute({ children }: Props) {
  const { organizationId, loading } = useUserData();

  // Aspetta il caricamento dei dati org prima di decidere (evita redirect spurio
  // durante il primo render della SPA).
  if (loading) return null;

  if (!canAccessBetaFeature(BETA_VOICE_AGENTS_ORG_IDS, organizationId)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
